import { render, staticRenderFns } from "./statistical-analysis-delays-and-response-time-detail.vue?vue&type=template&id=3897d78c&scoped=true&"
import script from "./statistical-analysis-delays-and-response-time-detail.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-delays-and-response-time-detail.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-delays-and-response-time-detail.scss?vue&type=style&index=0&id=3897d78c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3897d78c",
  null
  
)

export default component.exports